import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCPAppointmentListForAdmin } from "reduxStore/action/userAppointmentAction";
import strings from "translate/language";
import Breadcrumb from "component/common/breadcrumb";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import moment from "moment";
import { handleListResponse } from "utils/utils";
import ExcelJS from "exceljs";

const ChannelPartnerAppointmentReport = ({ isAuth = true }) => {
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [cpReportData, setCpReportData] = useState(null);
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [expandedRows, setExpandedRows] = useState({});
  const todayDate = new Date().toISOString().split("T")[0];
  const oneMonthAgoObj = new Date();
  oneMonthAgoObj.setMonth(oneMonthAgoObj.getMonth() - 1);
  const oneMonthAgo = oneMonthAgoObj.toISOString().split("T")[0];

  const [form, setForm] = useState({
    stl_name: "",
    sm_name: "",
    start_date: oneMonthAgo,
    end_date: todayDate,
    appoiment: 3,
  });
  const [loading, setLoading] = useState(true);
  const cpAppointmentReportDatas = useSelector((state) => state?.cpAppointment);
  useEffect(() => {
    dispatch(getCPAppointmentListForAdmin({ ...form }));
  }, []);

  useEffect(() => {
    const { response = null, create = false } = cpAppointmentReportDatas;
    if (response && response?.status === 200) {
      if (!create && response.data?.length > 0) {
        const result = handleListResponse(response?.data) ? response?.data : [];
        setCpReportData(result);
      } else {
        setCpReportData([]);
      }
    } else {
      setCpReportData([]);
    }
  }, [cpAppointmentReportDatas]);

  const handleSelectChange = (selectedOption) => {
    setForm({
      ...form,
      property_title: selectedOption ? selectedOption.value : "",
    });
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (
      (form.start_date && !form.end_date) ||
      (!form.start_date && form.end_date)
    ) {
      formError = true;
      err["date"] = strings.startEndDateErr;
    }

    setFormVaild(err);
    return formError;
  };

  const filterDetail = () => {
    if (!handleValid()) {
      setLoading(true);
      dispatch(getCPAppointmentListForAdmin({ ...form }));
    }
  };

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  const filterReset = () => {
    const resetForm = {
      stl_name: "",
      sm_name: "",
      start_date: oneMonthAgo,
      end_date: todayDate,
      appoiment: 3,
    };

    setForm(resetForm);
    setLoading(true);
    dispatch(getCPAppointmentListForAdmin({ ...resetForm }));
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    setFormVaild({ ...formVaild, [e.target.name]: "" });
  };

  const toggleExpand = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const exportToExcel = async () => {
    if (!cpReportData || cpReportData.length === 0) {
      alert("No data to export");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("ChannelPartnerAppointments");

    // Define columns exactly as shown in the table
    worksheet.columns = [
      { header: "Sr.No", key: "sno", width: 6 },
      { header: "Create Date", key: "createdatetime", width: 25 },
      { header: "Appointment Date", key: "appointmentdatetime", width: 25 },
      { header: "STL Name", key: "stlName", width: 25 },
      { header: "SM Name", key: "smName", width: 25 },
      { header: "CP Name", key: "cpName", width: 30 },
      { header: "CP Mobile Number", key: "mobile", width: 20 },
      { header: "CP Firm Name", key: "cpFirmName", width: 30 },
      { header: "Property", key: "allocatedProperty", width: 30 },
      { header: "Person Met", key: "personMet", width: 20 },
      { header: "Meet Type", key: "meetType", width: 20 },
      { header: "RERA Number", key: "reraNumber", width: 20 },
      { header: "Location", key: "location", width: 20 },
      { header: "Appointment Type", key: "appointmentType", width: 20 },
      { header: "Appointment Status", key: "appointmentStatus", width: 20 },
      { header: "Justo CP", key: "justoCP", width: 10 },
      { header: "Total Meetings Done", key: "totalMeetingsDone", width: 20 },
      { header: "Remark's", key: "remarks", width: 35 },
    ];

    // Add rows from cpReportData
    cpReportData.forEach((item, index) => {
      const date = item.appointment_date
        ? moment(item.appointment_date).format("DD-MM-YYYY")
        : "N/A";
      const time = item.appointment_time || "N/A";
      const createDate = item.create_Date
        ? moment(item.create_Date).format("DD-MM-YYYY hh:mm A")
        : "N/A";

      worksheet.addRow({
        sno: index + 1,
        createdatetime: `${createDate}`,
        appointmentdatetime: `${date} ${time}`,
        stlName: Array.isArray(item.sourcingTL_name)
          ? item.sourcingTL_name.join(", ")
          : item.sourcingTL_name || "N/A",
        smName: item.sender_name || "N/A",
        cpName: Array.isArray(item.receiver_name)
          ? item.receiver_name.join(", ")
          : item.receiver_name || "N/A",
        mobile: Array.isArray(item.non_reg_cp_mobile)
          ? item.non_reg_cp_mobile[0] || "N/A"
          : item.non_reg_cp_mobile || "N/A",
        cpFirmName: Array.isArray(item.cp_firm_name)
          ? item.cp_firm_name.join(", ")
          : item.cp_firm_name || "N/A",
        allocatedProperty: item.property_title || "N/A",
        personMet: item.user_type === 1 ? "Owner" : "Employee" || "N/A",
        meetType: item.meet_type || "N/A",
        reraNumber: item.rera_certificate_no || "N/A",
        location: item.cp_location || "N/A",
        appointmentType: item.appointment_type_title || "N/A",
        appointmentStatus:
          item.appointment_status === 1
            ? "Pending"
            : item.appointment_status === 2
            ? "Confirm"
            : item.appointment_status === 3
            ? "Completed"
            : item.appointment_status === 4
            ? "Cancelled"
            : "N/A",
        justoCP: item.registered_cp === 1 ? "YES" : "NO",
        totalMeetingsDone: item.total_meetings_done || "N/A",
        remarks: item.compleate_remark || "N/A",
      });
    });

    // Bold headers
    worksheet.getRow(1).font = { bold: true };

    // Export logic
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "ChannelPartnerAppointments.xlsx";
    link.click();
  };

  return (
    <div className="page-body">
      {isAuth && (
        <Breadcrumb
          title={strings.channelpartnerappointments}
          parentListing={null}
          titleactive={strings.channelpartnerappointmentsListing}
        />
      )}

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <form className="theme-form">
                <div className="row">
                  {/* Start Date */}
                  <div className="col-lg-4 col-md-6 mb-3">
                    <label className="form-label">{strings.startDate}</label>
                    <input
                      className="form-control"
                      type="date"
                      name="start_date"
                      value={form.start_date}
                      onChange={handleInputField}
                    />
                    {formVaild.start_date && (
                      <small className="text-danger">
                        {formVaild.start_date}
                      </small>
                    )}
                  </div>

                  {/* End Date */}
                  <div className="col-lg-4 col-md-6 mb-3">
                    <label className="form-label">{strings.endDate}</label>
                    <input
                      className="form-control"
                      type="date"
                      name="end_date"
                      value={form.end_date}
                      onChange={handleInputField}
                      min={form.start_date}
                      disabled={endDateDisable}
                    />
                    {formVaild.end_date && (
                      <small className="text-danger">
                        {formVaild.end_date}
                      </small>
                    )}
                  </div>

                  <div className="col-lg-4 col-md-12 mb-3">
                    <label className="form-label">
                      {strings.serchBySMName}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="sm_name"
                      value={form.sm_name}
                      onChange={handleInputField}
                      placeholder={strings.searchName}
                      autoComplete="off"
                    />
                  </div>
                  <div className="col-lg-4 col-md-6 mb-3">
                    <label className="form-label">
                      {strings.serchBySTLName}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="stl_name"
                      value={form.stl_name}
                      onChange={handleInputField}
                      placeholder={strings.searchName}
                      autoComplete="off"
                    />
                  </div>

                  {/* Action Buttons */}
                  <div className="col-lg-8 col-md-6 mb-3 d-flex align-items-end justify-content-end">
                    <div>
                      <button
                        className="btn btn-warning mr-4 me-2"
                        type="button"
                        onClick={filterDetail}
                      >
                        {strings.submit}
                      </button>
                      <button
                        className="btn btn-dark"
                        type="button"
                        onClick={filterReset}
                      >
                        {strings.reset}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {cpReportData && cpReportData.length > 0 ? (
            <div className="d-flex justify-content-end mr-4">
              <button className="btn btn-primary" onClick={exportToExcel}>
                Export to Excel
              </button>
            </div>
          ) : null}

          <hr />
          <div className="card">
            <div className="card-body">
              <div
                className="table-responsive"
                style={{ overflowY: "auto", overflowX: "auto" }}
              >
                {!cpReportData ? (
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    Loading...
                  </div>
                ) : cpReportData.length === 0 ? (
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    No data found
                  </div>
                ) : (
                  <table className="table table-striped table-bordered table-sm">
                    <thead
                      style={{
                        backgroundColor: "#ffffff",
                        color: "#000",
                        position: "sticky",
                        top: "0",
                        zIndex: 1,
                      }}
                    >
                      <tr>
                        <th style={{ minWidth: "60px", textAlign: "right" }}>
                          Sr. No.
                        </th>
                        <th style={{ minWidth: "200px", textAlign: "center" }}>
                          Created Date
                        </th>
                        <th style={{ minWidth: "200px", textAlign: "center" }}>
                          Appointment Date
                        </th>
                        <th style={{ minWidth: "170px", textAlign: "left" }}>
                          STL Name
                        </th>
                        <th style={{ minWidth: "170px", textAlign: "left" }}>
                          SM Name
                        </th>
                        <th style={{ minWidth: "170px", textAlign: "left" }}>
                          CP Name
                        </th>
                        <th style={{ minWidth: "140px", textAlign: "right" }}>
                          CP Mobile Number
                        </th>
                        <th style={{ minWidth: "170px", textAlign: "left" }}>
                          CP Firm Name
                        </th>
                        <th style={{ minWidth: "170px", textAlign: "left" }}>
                          Property
                        </th>
                        <th style={{ minWidth: "100px", textAlign: "left" }}>
                          Person Met
                        </th>
                        <th style={{ minWidth: "100px", textAlign: "left" }}>
                          Meet Type
                        </th>
                        <th style={{ minWidth: "150px", textAlign: "right" }}>
                          RERA Number
                        </th>
                        <th style={{ minWidth: "200px", textAlign: "left" }}>
                          Location
                        </th>
                        <th style={{ minWidth: "120px", textAlign: "left" }}>
                          Appointment Type
                        </th>
                        <th style={{ minWidth: "120px", textAlign: "left" }}>
                          Appointment Status
                        </th>
                        <th style={{ minWidth: "100px", textAlign: "center" }}>
                          Justo CP
                        </th>
                        <th style={{ minWidth: "120px", textAlign: "center" }}>
                          Total Meetings Done
                        </th>
                        <th style={{ minWidth: "250px", textAlign: "left" }}>
                          Remark's
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {cpReportData.map((item, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "right" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.create_Date
                              ? `${moment(item.create_Date).format(
                                  "DD-MM-YYYY hh:mm A"
                                )}`
                              : "N/A"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.appointment_date
                              ? `${moment(item.appointment_date).format(
                                  "DD-MM-YYYY"
                                )} ${item.appointment_time || "N/A"}`
                              : "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.sourcingTL_name || "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.sender_name || "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {Array.isArray(item.receiver_name)
                              ? item.receiver_name.join(", ")
                              : item.receiver_name || "N/A"}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {item.non_reg_cp_mobile || "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {Array.isArray(item.cp_firm_name)
                              ? item.cp_firm_name.join(", ")
                              : item.cp_firm_name || "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.property_title || "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.user_type === 1
                              ? "Owner"
                              : item.user_type === 2
                              ? "Employee"
                              : "Other CP"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.meet_type || "N/A"}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {item.rera_certificate_no || "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.cp_location || "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.appointment_type_title || "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.appointment_status === 1
                              ? "Pending"
                              : item.appointment_status === 2
                              ? "Confirm"
                              : item.appointment_status === 3
                              ? "Completed"
                              : item.appointment_status === 4
                              ? "Cancelled"
                              : "N/A"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.registered_cp === 1 ? "YES" : "NO"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.total_meetings_done || "N/A"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.compleate_remark || "N/A"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelPartnerAppointmentReport;
